import { useQuery } from "@tanstack/react-query";
import { getPlanOptions } from "../services/onboarding";

const useGetPlanOptions = ({ parceiroId, distribuidoraId }: { parceiroId: string; distribuidoraId: string }) => {
  return useQuery({
    queryKey: ["plan-options"],
    queryFn: async () => getPlanOptions(parceiroId, distribuidoraId),
    enabled: !!parceiroId && !!distribuidoraId,
  });
};

export { useGetPlanOptions };
